import React, { useState, useMemo } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { SelectOptionWithGroup, Select, Bubble } from 'tea-component';
import { useIntl } from 'umi';
import RenderGameIcon from '@/pages/opinion/components/RenderImg/renderGameIcon';
import { findGameInfo, useGameOperations } from '@/pages/opinion/utils/game';

export default function HeaderRow({
  detail,
  showSelect,
  sortCompetitorGames,
  deleteCompetitorGame,
  changeCompetitorGame,
}: any) {
  const [value, setValue] = useState('');
  const [showFlag, setShowFlag] = useState(false);
  const { formatMessage } = useIntl();
  const optionsList: SelectOptionWithGroup[] = useMemo(() => {
    function getTextShowInfo(t: any, name: string) {
      return (
        <div className="down-flex">
          <RenderGameIcon
            gameInfo={{
              entity_type: t.entity_type,
              cover: t.cover,
              edition_unified_id: t.edition_unified_id,
            }}
            className="down-img"
          ></RenderGameIcon>
          <div className={`down-text ${!showSelect ? 'no-select' : ''}`}>
            {name}
          </div>
        </div>
      );
    }
    let options =
      [detail, ...(detail.mobile_edition_list || [])]?.map(
        (t: any, index: number) => {
          return {
            originText: getTextShowInfo(t, t.entity_name),
            value: t.edition_unified_id,
            text: getTextShowInfo(
              t,
              index === 0
                ? formatMessage({ id: 'All Editions' })
                : t.entity_name,
            ),
          };
        },
      ) || [];

    return options;
  }, [detail, formatMessage]);

  const { handleChangeGame } = useGameOperations();

  const [currentGameInfo, selectId] = useMemo(() => {
    let { selected_edition_unified_id } = detail;
    const item = optionsList.find(
      (item) => item.value === selected_edition_unified_id,
    );
    return [item?.originText, selected_edition_unified_id];
  }, [detail]);

  const buttonElement = useMemo(() => {
    return (
      <div className="header-item-box">
        <span
          onClick={() => {
            const [game] = findGameInfo([detail], selectId) || [];
            handleChangeGame(game, true);
            return;
          }}
        >
          {currentGameInfo}
        </span>
        <span
          onClick={() => {
            setShowFlag(!showFlag);
          }}
        >
          {showSelect && (
            <SvgIcon type="fill-icon-arrow" className="header-item-icon" />
          )}
        </span>
      </div>
    );
  }, [detail, optionsList, showSelect, showFlag, selectId]);

  return (
    <div className="header-item">
      {showSelect ? (
        <Select
          onBlur={() => setShowFlag(false)}
          open={showFlag}
          button={buttonElement}
          value={value || selectId}
          options={optionsList}
          appearance="pure"
          overlayClassName="dbo-card-tip"
          placement="bottom"
          onChange={(value) => {
            setValue(value);
            changeCompetitorGame(value);
            setShowFlag(false);
          }}
        ></Select>
      ) : (
        buttonElement
      )}

      <Bubble
        dark
        closeOnScroll
        content={formatMessage({ id: 'Remove this game' })}
      >
        <i className="header-item-close" onClick={deleteCompetitorGame}>
          <SvgIcon type="delete-bg-icon" />
        </i>
      </Bubble>
      <Bubble
        dark
        closeOnScroll
        content={formatMessage({ id: 'Exchange position' })}
      >
        <i className="header-item-exchange" onClick={sortCompetitorGames}>
          <SvgIcon type="exchange-icon" />
        </i>
      </Bubble>
    </div>
  );
}
